import { render, staticRenderFns } from "./UpLowPaging.vue?vue&type=template&id=86684df8&scoped=true&"
import script from "./UpLowPaging.vue?vue&type=script&lang=js&"
export * from "./UpLowPaging.vue?vue&type=script&lang=js&"
import style0 from "./UpLowPaging.vue?vue&type=style&index=0&id=86684df8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86684df8",
  null
  
)

export default component.exports